// extracted by mini-css-extract-plugin
export var container = "ToasterItem-module--container--7e170";
export var giftWrap = "ToasterItem-module--giftWrap--3e6d9";
export var image = "ToasterItem-module--image--90e57";
export var label = "ToasterItem-module--label--89c84";
export var name = "ToasterItem-module--name--d11e7";
export var price = "ToasterItem-module--price--f40b8";
export var productInfo = "ToasterItem-module--productInfo--28d5d";
export var variant = "ToasterItem-module--variant--90591";